/* Hjemvia : sur mobile, la barre d'achat collante de Horizon s'affiche des l'arrivee,
   tant que le vrai bouton « Laeg i kurv » n'est pas encore a l'ecran.
   Horizon ne la montre qu'une fois le bouton depasse vers le haut : un visiteur qui ne
   fait pas defiler ne voit donc jamais de bouton d'achat (Clarity 28-30/09 : la moitie
   des sessions mobiles sur fiche produit restent sous 10 % de defilement, le bouton
   est a ~1 040 px pour un ecran de 812).
   On ne touche qu'a l'attribut data-stuck, celui que Horizon pilote lui-meme :
   - bouton sous l'ecran (mobile) : barre affichee ;
   - bouton visible : barre masquee, pas de doublon ;
   - bouton depasse vers le haut : on ne fait rien, c'est le comportement de Horizon.
   Les elements sont relus a chaque passage, car Horizon peut re-rendre la section. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var ticking = false;

  function check() {
    ticking = false;
    var bar = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__bar');
    var block = document.querySelector('.buy-buttons-block');
    if (!bar || !block) return;
    var r = block.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!vh || (r.top === 0 && r.bottom === 0)) return; // page pas encore mise en page
    var stuck = bar.getAttribute('data-stuck') === 'true';
    if (r.top >= vh) {
      if (mq.matches && !stuck) bar.setAttribute('data-stuck', 'true');
    } else if (r.bottom > 0) {
      if (stuck) bar.setAttribute('data-stuck', 'false');
    }
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(check);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  [300, 1000, 2500].forEach(function (t) { setTimeout(schedule, t); });
  schedule();
})();
